// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__mye+3","info":"Panel_info__euLjz","btns":"Panel_btns__5trsW","button":"Panel_button__-+YS-"};